import {
  Box,
  Text,
  Button,
  Flex,
  Textarea,
} from "@chakra-ui/react";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { useMemo } from "react";
import axios from "axios";
import { useAuth } from '../Components/auth/AuthProvider';
import { useSurvey } from "./BusinessSurveyContext";


export default function BusinessSurveyLoanInfo2() {
  const navigate = useNavigate();
  const { surveyData, updateSurveyData } = useSurvey();
  const { name, email, businessName, industry, years, employees, description, loanAmount, monthlySales, monthlyExpenses, bookKeeping, repaymentPlan, loanPurpose } = surveyData || {};
  const { user, token } = useAuth();

  const config = useMemo(() => ({
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }), [token]);


  const handleSubmit = async () => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    if (
      !name ||
      !email ||
      !businessName ||
      !industry ||
      years === null || years === undefined ||
      employees === null || employees === undefined ||
      !description ||
      monthlySales === null || monthlySales === undefined ||
      monthlyExpenses === null || monthlyExpenses === undefined ||
      !bookKeeping.trim() ||
      !repaymentPlan.trim() ||
      !loanPurpose.trim()
    ) {
      alert("Please complete all required fields before submitting.");
      return;
    }

    const payload = {
      name: name,
      email: email,
      business_name: businessName,
      industry: industry,
      years: Number(years),
      num_employees: employees,
      description: description,
      avg_monthly_sales: Number(monthlySales),
      avg_monthly_expenses: Number(monthlyExpenses),
      book_keeping: bookKeeping,
      repayment_plan: repaymentPlan,
      student_id: user,
      loan_purpose: loanPurpose,
    };
    console.log("Payload to be sent:", payload);

    try {
      const res = await axios.post(`${baseUrl}/business-loan`, payload, config);
      console.log("Loan submitted successfully:", res.data);

      // Navigate to the final screen, passing data if needed
      navigate("/business-survey-end");
    } catch (error) {
      console.error("Submission failed:", error);
      alert("There was an error submitting your loan application.");
    }
  };


  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black">
          RESOURCES
        </Text>
      </Box>

      {/* Main Content */}
      <Box
        flex="1"
        overflowY={["auto", "auto", "visible"]}
        px={4}
        pt={6}
        pb={["140px", "160px"]}
        display="flex"
        justifyContent="center"
        minHeight={{ base: "auto", md: "calc(100vh - 200px)" }}
      >
        <Box width="100%" maxW="480px">
          {/* Back Arrow */}

          {/* Title */}
          <Text fontWeight="bold" fontSize="xl" mb={1} textAlign={"center"}>
            Pilot Small Business Assistance Application Survey
          </Text>


          {/* Progress Bar */}
          <Box
            width="100%"
            maxW={{ base: "360px", md: "440px" }}
            mx="auto"
            mb={10}
            height="32px"
            border="2px solid black"
            borderRadius="full"
            overflow="hidden"
          >
            <Box
              width="80%"
              height="100%"
              bg="#00C49A"
              borderRightRadius="full"
            />
          </Box>

          {/* Form Fields */}
          <Box mb={12}>
            <Box mb={4}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                What are you going to use the loan for?
              </Text>
              <Textarea
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                value={loanPurpose || ""}
                onChange={(e) => updateSurveyData({ loanPurpose: e.target.value })}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
                rows={4}
              />
            </Box>
            <Box mb={4}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Repayment Plan Strategy
              </Text>
              <Textarea
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                value={repaymentPlan}
                onChange={(e) => updateSurveyData({ repaymentPlan: e.target.value })}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
                rows={4}
              />
            </Box>
            <Box mb={4}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                How do you currently track your business income and expenses?
              </Text>
              <Textarea
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                value={bookKeeping || ""}
                onChange={(e) => updateSurveyData({ bookKeeping: e.target.value })}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
                rows={2}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Back/Next Buttons */}
      <Box
        position="absolute"
        bottom={["110px", "120px"]}
        width="100%"
        bg="white"
        py={3}
        px={6}
        display="flex"
        justifyContent="space-between"
        zIndex={10}
      >
        <Button
          variant="ghost"
          leftIcon={<FaArrowLeft color="#00C49A" />}
          color="black"
          onClick={() => navigate("/business-app-4")}
        >
          Back
        </Button>
        <Button
          variant="ghost"
          onClick={handleSubmit}
          rightIcon={<FaArrowRight color="#00C49A" />}
          color="black"
        >
          Submit
        </Button>
      </Box>

      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      >
      </Flex>
    </Box>
  );
}
